import React, { Component } from "react";
import {
  Input,
  Button,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import * as Constdata from "../../Constants/ApiConstants";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import * as message from "../../Constants/MessageConstant";
import ReactGA from "react-ga4";
import { connect } from "react-redux";
import {
  reset,
  setDataSourcePayload,
} from "../../reducers/dataSourcePayloadSlice";

class SaAccountCreationPPU extends Component {
  constructor(props) {
    super(props);
    this.handleSumbit = this.handleSumbit.bind(this);
    this.processResponse = this.processResponse.bind(this);
    this.toggle = this.toggle.bind(this);
    this.IsDisabled = this.IsDisabled.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.toggleShow = this.toggleShow.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      orgId: "",
      fields: this.props.AccountEdit === true ? this.props.data : {},
      errors: {},
      modal: false,
      provider: "",
      modalLoader: false,
      errormessage: "",
      errorPopup: false,
      hidden: true,
      isRedirect: false,
      modalAccntAddedPopup: false,
      loader: false,
    };
  }

  componentDidMount() {
    // ReactGA.initialize(message.MeasurementId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: window.location.pathname,
    //   title: "Account Creation",
    // });
  }
  toggleShow = () => {
    this.setState({ hidden: !this.state.hidden });
  };
  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    //Name
    if (!fields["staticIp"]) {
      formIsValid = false;
      errors["staticIp"] = "IP Address cannot be empty";
    }
    //accountSecret
    if (!fields["userName"]) {
      formIsValid = false;
      errors["userName"] = "User Name cannot be empty";
    }

    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "Password cannot be empty";
    }

    this.setState({ errors: errors });
    return formIsValid;
  }
  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  handleChange(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.value;
    this.setState({ fields });
  }
  handleStoreSecret(field, e) {
    let fields = this.state.fields;
    fields[field] = e.target.checked;
    this.setState({ fields });
  }
  handleSumbit = (e) => {
    console.log("enter");
    e.preventDefault();
    const { accountname, staticIp, userName, password, id, isCPOEnabled } =
      this.state.fields;
    const payload = {
      accountname: accountname,
      staticIp: staticIp,
      userName: userName,
      password: password,
      //   storeSecret: true,
      isEdit: this.props.AccountEdit,
      id: id,
      isCPOEnabled: isCPOEnabled,
    };
    var resPayload = this.props.dataSourcePayload;
    if (!this.props.AccountEdit) {
      if (this.props.dataRes) {
        if (this.props.dataRes.some((val) => val.staticIp == staticIp)) {
          this.setState({
            errormessage:
              "Standalon configuration with Account Key is already added",
            errorPopup: true,
            setErrorPopupState: "",
          });
          return false;
        }
      }
      if (resPayload && resPayload.some((val) => val.password == password)) {
        this.setState({
          errormessage: "Standalon credentials in progress",
          errorPopup: true,
          setErrorPopupState: "",
        });
        return false;
      } else {
        if (resPayload) {
          this.props.setDataSourcePayload([
            ...this.props.dataSourcePayload,
            { ...payload, status: "FETCHING", id: staticIp },
          ]);
        } else {
          this.props.setDataSourcePayload([
            { ...payload, status: "FETCHING", id: staticIp },
          ]);
        }
        this.props.cancelAccount();
      }
    } else {
      if (resPayload) {
        this.props.setDataSourcePayload([
          ...this.props.dataSourcePayload,
          { ...payload, status: "FETCHING", id: staticIp },
        ]);
      } else {
        this.props.setDataSourcePayload([
          { ...payload, status: "FETCHING", id: staticIp },
        ]);
      }
      this.props.updateStatusOnSubmit(staticIp, "STANDALONE");
    }
    this.setState({ loader: true });

    if (!this.handleValidation()) {
      return;
    }
    fetch(Constdata.ADDUPDATE_STANDALON_CONFIG_URL, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        var newArr = this.props.dataSourcePayload.filter(
          (x) => x.staticIp != staticIp
        );
        this.props.setDataSourcePayload(newArr);
        this.setState({ loader: false });
        this.processResponse(responseJson);
        this.props.addDataSourcesResponse(responseJson, "");
      })
      .catch((error) => {
        console.error(error);
      });
  };
  processResponse(response) {
    if (response.success === true) {
      this.setState(function () {
        return { orgId: response.data.orgId, configId: response.data.configId };
      });
      this.props.handleFetch();
      // this.props.cancelAccount();
    } else {
      this.props.handleFetch();
    }
  }

  IsDisabled = () => {
    const { staticIp, userName, password } = this.state.fields;
    return (
      !staticIp ||
      !userName ||
      !password ||
      this.state.modalLoader ||
      this.state.loader
    );
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push("/");
    }
  };

  render() {
    return (
      <div>
        <div className="container-verf" style={{ width: "100%" }} role="main">
          <div className="modalTitleDS">
            {this.props.AccountEdit === true
              ? "Update Standalon Metrics Data Source"
              : "Add Standalon Metrics Data Source"}
          </div>
          <div
            className="account_container"
            style={{ position: "relative", marginTop: "20px" }}
          >
            <form>
              <div className="form-group">
                <label htmlFor="accountname">
                  Standalon Metrics Data Source Name:
                </label>
                <Input
                  placeholder="Provide Name for this Standalon Data Source"
                  type="text"
                  id="accountname"
                  name="accountname"
                  value={this.state.fields["accountname"]}
                  onChange={this.handleChange.bind(this, "accountname")}
                  disabled={this.props.AccountEdit}
                />
                <span style={{ color: "red" }}>
                  {this.state.errors["accountname"]}
                </span>
              </div>
              <div className="form-group">
                <label htmlFor="staticIp">IP Address:</label>
                <Input
                  placeholder="IP Address"
                  type="text"
                  id="staticIp"
                  name="staticIp"
                  value={this.state.fields["staticIp"]}
                  onChange={this.handleChange.bind(this, "staticIp")}
                  disabled={this.props.AccountEdit}
                />
                <span style={{ color: "red" }}>
                  {this.state.errors["staticIp"]}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="userName">User Name:</label>
                <InputGroup>
                  <Input
                    placeholder="User Name"
                    type={"text"}
                    id="userName"
                    name="userName"
                    value={this.state.fields["userName"]}
                    onChange={this.handleChange.bind(this, "userName")}
                  />
                </InputGroup>
                <span style={{ color: "red" }}>
                  {this.state.errors["userName"]}
                </span>
              </div>

              <div className="form-group">
                <label htmlFor="password">Password:</label>
                <InputGroup>
                  <Input
                    placeholder="Password"
                    type={this.state.hidden ? "password" : "text"}
                    id="password"
                    name="password"
                    value={this.state.fields["password"]}
                    onChange={this.handleChange.bind(this, "password")}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <i
                        className="fa fa-eye-slash"
                        onClick={this.toggleShow}
                      ></i>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
                <span style={{ color: "red" }}>
                  {this.state.errors["password"]}
                </span>
              </div>

              <div className="prim_But">
                <Button
                  id={this.IsDisabled() ? "btn_disabled" : "btnaccount_save"}
                  type="submit"
                  disabled={this.IsDisabled()}
                  onClick={this.handleSumbit}
                >
                  {this.props.AccountEdit === true ? "Update" : "Add"}
                </Button>
                <Button
                  id={
                    this.state.loader
                      ? "btncancel_disabled"
                      : "btnaccount_cancel"
                  }
                  onClick={this.props.cancelAccount}
                  disabled={this.state.loader}
                >
                  Cancel
                </Button>
              </div>
              {this.state.loader === true ? (
                <SerraLoader loader="true"></SerraLoader>
              ) : (
                ""
              )}
            </form>
          </div>
          {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
          {this.state.errorPopup === true ? (
            <SerraError
              Errordata={this.state.errormessage}
              ErrorPopup={this.state.errorPopup}
              setErrorMethod={this.setErrorPopupState}
              isError={this.state.isErrorHeader}
              subTitle={this.state.subTitle}
            ></SerraError>
          ) : (
            ""
          )}
          {/* <Modal size="lg" isOpen={this.state.modal} toggle={this.toggle}>
              <ModalHeader id="modalheader_list" toggle={this.toggle} cssModule={{'modal-title': 'w-100 text-center'}}><div  dangerouslySetInnerHTML={{__html: message.SerraLabsModalHeader}} /> </ModalHeader>
              <ModalBody>
                  <div  dangerouslySetInnerHTML={{__html: message.AzureClientInstructionText}}/>
                  <div  dangerouslySetInnerHTML={{__html: message.AzureVmDiagnosticList}}/>
              </ModalBody>
              <ModalFooter id="knowMoreFooter">
                  <Button id="confirmbtn_list" onClick={this.toggle}>OK</Button>
              </ModalFooter>
          </Modal> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataSourcePayload: state.dataSourcePayload.payload,
    companyDetails: state.companyDetails.data,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetDataSourcePayload: () => dispatch(reset()),
    setDataSourcePayload: (data) => dispatch(setDataSourcePayload(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SaAccountCreationPPU);
